import { context, type Span, trace } from '@opentelemetry/api';
import { apiGet } from '@/api/apiClient';
import type { Destination } from '@/api/destinations/types';
import type { LocalizedString } from '@/api/types';
import { instrumentAsync } from '@/otel';
import { destinationImages } from '@/utilities/images/destinationImages';

interface DestinationApi {
  code: string;
  name: LocalizedString;
  cruise_count: number;
}

export async function getDestinations(): Promise<Destination[]> {
  return await instrumentAsync(
    'api.destinations.getDestinations',
    async (span: Span) => {
      const res = await apiGet<DestinationApi[]>(
        '/destinations',
        trace.setSpan(context.active(), span),
      );

      return res.data.map((d) => ({
        ...d,
        photo_url: destinationImages[d.code.toLowerCase().split(' ').join('-')],
      }));
    },
  );
}
